import { Button, Image, Space, Typography } from 'antd';
import React from 'react';
import { DISCORD_LINK, TWITTER_LINK } from "../Constants";
import * as analytics from "../services/Analytics";

export function Community() {

    return (

        <div className="layout-content-element" style={{ background: 'transparent' }} id="community">
            <Space direction='vertical' align="center" style={{ width: "100%", textAlign: "center" }}>
                <div style={{ margin: "24px 0px" }}>
                    <Image src={require("../assets/community_animation.gif")} preview={false} width={"75%"} />
                </div>
                <Typography.Title level={1}><span style={{ fontWeight: "100" }}>Let's build</span> Crypto Space Prison <span style={{ fontWeight: "100" }}>together!</span></Typography.Title>
                <Typography.Title level={4} style={{ fontWeight: "300" }}>🤝 Join the community!</Typography.Title>
                <Space direction='horizontal' size='large' style={{ margin: "12px 0px" }}>
                    <Button size='large' type='primary' href={DISCORD_LINK} target="_blank" onClick={() => analytics.clickOpenDiscord()}>Discord</Button>
                    <Button size='large' type='primary' href={TWITTER_LINK} target="_blank" onClick={() => analytics.clickOpenTwitter()}>Twitter</Button>
                </Space>
            </Space>
        </div>
    )

}